import { HomeModernIcon } from './HomeModernIcon';

/**
 * author: Austin Andrews
 * id 6949FE9A-5B8C-4EDF-B74E-E0268A4F69F1
 * name home-modern
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-modern.svg
 * tags
 * - Home Automation 
 */
export const HouseModernIcon = HomeModernIcon;
export default HouseModernIcon